import { Injectable } from '@angular/core';

import { LoggerWrapper } from './logger-wrapper.service';

/**
 * Logger Factory
 *
 * Ce service permet de récupérer une instance du logger
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerFactory {
  /**
   * Constructeur
   * Instancier le logger associé à la classe
   *
   * @example export class HomePage {
   *   private logger: LoggerWrapper;
   *   constructor(
   *     private loggerFactory: LoggerFactory
   *   ) {
   *    // Use logger in order to be able to set logLevel
   *    this.logger = this.loggerFactory.getInstance(this);
   *   }
   *   ionViewDidLoad() {
   *     this.logger.log('ionViewDidLoad HomePage');
   *   }
   * }
   */
  constructor() {}

  /**
   * Récupérer le logger associé à la classe passée en paramètres
   * utilise console.log et assimilés
   * @param object La classe où on veut utiliser le logger
   * @param enableDatadogLogs Activation de l'envoi des logs vers Datadog
   * @returns {LoggerWrapper} l'instance du logger à utiliser
   */
  getInstance(object: any, enableDatadogLogs: boolean = false): LoggerWrapper {
    const logger: LoggerWrapper = new LoggerWrapper();
    logger.setName(object);
    logger.setEnableDatadogLogs(enableDatadogLogs);
    return logger;
  }
}
